// Mirrors the backend SubscriptionTier enum.
export const SubscriptionTier = {
  Free: 'free',
  Pro: 'pro',
  Enterprise: 'enterprise',
} as const;

export type SubscriptionTier =
  (typeof SubscriptionTier)[keyof typeof SubscriptionTier];
